import axios from 'axios'
import getServerURL from '../../../functions/getServerURL'

import { getMetadata } from '../../projects/reducers/manageProjects'
import { getNotifications } from "../../notifications/reducers/manageNotifications"
import swal from "sweetalert"

let defaultState = {
  user: {},
  isAuthenticating: false,
  users: [],
  genesisUsers: [],
  clients: [],
  fetchingClients: false,
  roles: [],
  fetchingRoles: false,
  teams: [],
  fetchingTeams: false,
  // clientContacts: [],
  // billingCodes: [],
  // qcLevels: [],
}

export default function manageLogin(state = defaultState, action) {
  switch (action.type) {
    case "SET_USER":
      return {
        ...state,
        user: action.payload
      }
    case "SET_IS_AUTHENTICATING":
      return {
        ...state,
        isAuthenticating: action.payload
      }
    case "SET_USERS":
      return {
        ...state,
        users: action.payload.users,
        genesisUsers: action.payload.genesisUsers
      }
    case "ADD_USER":
      return {
        ...state,
        users: [...state.users, action.payload]
      }
    case "EDIT_USER":
      const indexOfUser = state.users.findIndex(user => user.id === action.payload.id)
      const users = [...state.users.slice(0, indexOfUser), action.payload, ...state.users.slice(indexOfUser + 1)]
      return {
        ...state,
        users,
      }
    case "REMOVE_INITIAL_LOGIN":
      return {
        ...state,
        user: { ...state.user, initial_login: false }
      }
    case "FETCHING_CLIENTS":
      return { ...state, fetchingClients: true }
    case "SET_CLIENTS":
      return {
        ...state,
        clients: action.payload,
        fetchingClients: false,
      }
    case "ADD_CLIENT":
      return {
        ...state,
        clients: [...state.clients, action.payload],
      }
    case "FETCHING_ROLES":
      return { ...state, fetchingRoles: true }
    case "SET_ROLES":
      return {
        ...state,
        roles: action.payload,
        fetchingRoles: false,
      }
    case "ADD_ROLE":
      return {
        ...state,
        roles: [...state.roles, action.payload],
      }
    case "EDIT_ROLE":
      return {
        ...state,
        roles: sliceAndEditArrayOfObjects(state.roles, action.payload, 'url'),
      }
    case "FETCHING_TEAMS":
      return { ...state, fetchingTeams: true }
    case "SET_TEAMS":
      return {
        ...state,
        teams: action.payload,
        fetchingTeams: false,
      }
    case "ADD_TEAM":
      return {
        ...state,
        teams: [...state.teams, action.payload],
      }
    case "EDIT_TEAM":
      return {
        ...state,
        teams: sliceAndEditArrayOfObjects(state.teams, action.payload, 'url'),
      }
    case "PROMOTE_OR_DEMOTE_USER":
      const userToUpdateIndex = state.users.findIndex(user => user.url === action.payload)
      let userToUpdate = state.users[userToUpdateIndex]

      userToUpdate = { ...userToUpdate, is_manager: !userToUpdate.is_manager }
      const updatedUsers = [
        ...state.users.slice(0, userToUpdateIndex),
        userToUpdate,
        ...state.users.slice(userToUpdateIndex + 1),
      ]

      return { ...state, users: updatedUsers }
    // case "SET_CLIENT_CONTACTS":
    //   return {
    //     ...state,
    //     clientContacts: action.payload
    //   }
    // case "ADD_CLIENT_CONTACTS":
    //   return {
    //     ...state,
    //     clientContacts: [ ...state.clientContacts, action.payload ]
    //   }
    // case "SET_BILLING_CODES":
    //   return {
    //     ...state,
    //     billingCodes: action.payload
    //   }
    // case "SET_QC_LEVELS":
    //   return {
    //     ...state,
    //     qcLevels: action.payload
    //   }
    default:
      return state
  }
}


const sliceAndEditArrayOfObjects = (array, element, field) => {
  const index = array.findIndex(obj => obj[field] === element[field])
  if (index < 0) {
    return array
  }
  return [
    ...array.slice(0, index),
    element,
    ...array.slice(index + 1),
  ]
}

export const setUser = (data) => {
  return { type: "SET_USER", payload: data }
}

export const addUser = (user) => {
  return { type: "ADD_USER", payload: {...user, password: null } }
}

export const editUser = (user) => {
  return { type: "EDIT_USER", payload: user }
}

const setUsers = (data) => {
  return { type: "SET_USERS", payload: data }
}

export const removeInitialLogin = () => {
  return { type: "REMOVE_INITIAL_LOGIN" }
}

const fetchingClients = () => {
  return { type: "FETCHING_CLIENTS" }
}

const setClients = (data) => {
  return { type: "SET_CLIENTS", payload: data }
}

export const addClient = (client) => {
  return { type: "ADD_CLIENT", payload: client }
}

const fetchingRoles = () => {
  return { type: "FETCHING_ROLES" }
}

const setRoles = (data) => {
  return { type: "SET_ROLES", payload: data }
}

export const addRole = (role) => {
  return { type: "ADD_ROLE", payload: role }
}

export const editRole = (role) => {
  return { type: "EDIT_ROLE", payload: role }
}

const fetchingTeams = () => {
  return { type: "FETCHING_TEAMS" }
}

const setTeams = (data) => {
  return { type: "SET_TEAMS", payload: data }
}

export const addTeam = (team) => {
  return { type: "ADD_TEAM", payload: team }
}

export const editTeam = (team) => {
  return { type: "EDIT_TEAM", payload: team }
}



export const promoteOrDemoteUserRedux = (user) => {
  return { type: "PROMOTE_OR_DEMOTE_USER", payload: user }
}

const checkToken = () => {
  return dispatch => {
    axios({
      url: `${getServerURL()}token-check/`,
      method: "GET",
      headers:{
        "Authorization": "Bearer " + localStorage.getItem("token")
      }
    })
    .then(response => {
      dispatch(setUser(response.data.user))
      dispatch(getNotifications(response.data.user.pk))
    })
    .catch(error => {
      if (window.localStorage.getItem('token')) {
        let rememberMe = ""
        if(localStorage.getItem("rememberMe")) rememberMe = localStorage.getItem("rememberMe")
        localStorage.clear()
        if(rememberMe){
          localStorage.setItem("rememberMe", rememberMe)
        }
        window.location = '/'
      }
    })
  }
}

export const checkSSOToken = () => {
  return dispatch => {
    let query = window.location.search
    if (query) {
      if (query.includes("token") && query.includes("uid")) {
        let queryArr = query.split("&")
				let token = queryArr[1].slice(6)
        swal({
          text: "Logging in.",
          icon: require("../../../static/images/spinner.gif"),
          button: false
        })
        dispatch({ type: "SET_IS_AUTHENTICATING", payload: true })
        // dispatch({ type: "SET_IS_AUTHENTICATED", payload: false })
        axios.get(`${ getServerURL() }token-check/`, {
          headers:{ "Authorization": "Bearer " + token }
        }).then(response => {
          console.log(response)
          localStorage.setItem("token", token)
          // NOTE: We previously dispatched getNotifications here immediately after SSO login.
          // Keeping it commented for reference:
          // dispatch(getNotifications(response.data.user.pk))
          // Reason: Right after this block we clear window.location.search which triggers a navigation.
          // Firefox cancels in-flight requests on navigation, which used to cause a transient
          // "There was an error fetching your notifications" alert when this request got aborted.
          // Notifications will be fetched via the normal post-login flow (checkToken) after reload,
          // so this call is redundant here. If we later switch to history.replaceState to avoid a
          // navigation, we can re-enable this line.
          dispatch(setUser(response.data.user))
          dispatch(getUsers())
          dispatch(getMetadata())
          dispatch(getClients())
        }).catch(error => {
          dispatch({ type: "SET_IS_AUTHENTICATING", payload: false })
          console.log(error, error.response)
        }).finally(() => {
          swal.close()
          window.location.search = ""
        })
      } else {
        dispatch(checkToken())
      }
    } else {
      dispatch(checkToken())
    }
  }
}

export const loginUser = (username, password, history, rememberMe) => {
  return function(dispatch) {
    axios({
      method:"POST",
      url: `${getServerURL()}login/`,
      data: {
        username: username,
        password: password
      }
    })
    .then(response => {
      // REMEMBERING THE TOKEN
      localStorage.setItem("token",response.data.access)

      // CHECKING IF THE USER CHECKED 'Remember me' AT LOGIN
      if (rememberMe) {
        localStorage.setItem("rememberMe", username)
      } else {
        localStorage.removeItem("rememberMe")
      }

      // GETING ALL THE NECESSARY DATA AND STORING IT IN THE REDUX STORE
      dispatch(setUser(response.data.user))
      dispatch(getUsers())
      dispatch(getMetadata())
      dispatch(getClients())

      // THE LINE BELOW REDIRECTS TO THE MAIN PAGE AFTER LOGIN
      history.push('/')
    })
    .catch(error => {
      if (error.response && error.response.status === 400) {
        document.getElementById('error-field').innerText = "Invalid credentials"
      } else {
        document.getElementById('error-field').innerText = "The server is down"
      }
    })
  }
}

export const getUsers = () => {
  return function(dispatch) {
    axios.get(`${getServerURL()}users/`, {
      headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
    })
    .then(response => {
      const users = response.data
      const genesisUsers = users.filter(user => user.email.includes("@genesisrg.com"))
      dispatch(setUsers({ users: users, genesisUsers: genesisUsers }))
    })
    .catch(error => {
      if (error.response && error.response.status === 401) {
        let rememberMe = ""
        if (localStorage.getItem("rememberMe")) {
          rememberMe = localStorage.getItem("rememberMe")
          localStorage.clear()
        }
        if (rememberMe) {
          localStorage.setItem("rememberMe", rememberMe)
        }
        window.location = '/'
      }
    })
  }
}

export const getClients = (params = {}) => {
  return (dispatch) => {
    dispatch(fetchingClients())
    axios.get(`${getServerURL()}client/`, {
      params,
      headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
    })
    .then(response => {
      dispatch(setClients(response.data))
    })
    .catch(error => {
      if (error.response && error.response.status === 401) {
        let rememberMe = ""
        if(localStorage.getItem("rememberMe")) {
          rememberMe = localStorage.getItem("rememberMe")
          localStorage.clear()
        }
        if (rememberMe) {
          localStorage.setItem("rememberMe", rememberMe)
        }
        window.location = '/'
      }
    })
  }
}

export const getRoles = () => {
  return (dispatch) => {
    dispatch(fetchingRoles())
    axios.get(`${getServerURL()}roles/`, {
      headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
    })
    .then(response => {
      dispatch(setRoles(response.data))
    })
    .catch(error => {
      if (error.response && error.response.status === 401) {
        let rememberMe = ""
        if(localStorage.getItem("rememberMe")) {
          rememberMe = localStorage.getItem("rememberMe")
          localStorage.clear()
        }
        if (rememberMe) {
          localStorage.setItem("rememberMe", rememberMe)
        }
        window.location = '/'
      }
    })
  }
}

export const getTeams = () => {
  return (dispatch) => {
    dispatch(fetchingTeams())
    axios.get(`${getServerURL()}teams/`, {
      headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
    })
    .then(response => {
      dispatch(setTeams(response.data))
    })
    .catch(error => {
      if (error.response && error.response.status === 401) {
        let rememberMe = ""
        if(localStorage.getItem("rememberMe")) {
          rememberMe = localStorage.getItem("rememberMe")
          localStorage.clear()
        }
        if (rememberMe) {
          localStorage.setItem("rememberMe", rememberMe)
        }
        window.location = '/'
      }
    })
  }
}












// const setClientContacts = (data) => {
//   return { type: "SET_CLIENT_CONTACTS", payload: data }
// }
//
// export const addClientContacts = (data) => {
//   return { type: "ADD_CLIENT_CONTACTS", payload: data }
// }

// const setBillingCodes = (data) => {
//   return { type: "SET_BILLING_CODES", payload: data }
// }

// export const getClientContacts = () => {
//   return function(dispatch) {
//     axios.get(`${getServerURL()}client-contacts/`, {
//       headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
//     })
//     .then(response => {
//       dispatch(setClientContacts(response.data))
//     })
//     .catch(error => {
//       if (error.response && error.response.status === 401) {
//         let rememberMe = ""
//         if(localStorage.getItem("rememberMe")) {
//           rememberMe = localStorage.getItem("rememberMe")
//           localStorage.clear()
//         }
//         if (rememberMe) {
//           localStorage.setItem("rememberMe", rememberMe)
//         }
//         window.location = '/'
//       }
//     })
//   }
// }

// export const getBillingCodes = () => {
//   return function(dispatch){
//     axios.get(`${getServerURL()}billing-codes/`, {
//       headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
//     })
//     .then(response => {
//       dispatch(setBillingCodes(response.data))
//     })
//     .catch(error => {
//       if (error.response && error.response.status === 401) {
//         let rememberMe = ""
//         if(localStorage.getItem("rememberMe")) {
//           rememberMe = localStorage.getItem("rememberMe")
//           localStorage.clear()
//         }
//         if (rememberMe) {
//           localStorage.setItem("rememberMe", rememberMe)
//         }
//         window.location = '/'
//       }
//     })
//   }
// }



// WEBPACK FOOTER //
// ./src/routes/login/reducers/manageLogin.js